<template>
    <v-container container--fluid>
        <v-layout row wrap align-center justify-space-around class="pa-2 mx-auto">
            <v-flex xs12 class="text-left">
                <h1 class="grey--text lighten-3 mb-2">Invoices</h1>
                <v-card class="elevation-12">
                    <v-card-title>
                        Invoices List
                        <v-spacer></v-spacer>
                        <v-text-field v-model="search" append-icon="search" label="Search" clearable single-line hide-details></v-text-field>
                    </v-card-title>
                    <v-data-table :search="search" :loading="invoicesLoading" :items-per-page="10" :headers="headers" :items="invoices" item-key="t_id" class="elevation-1">
                        <template slot="item" slot-scope="props">
                            <tr>
                                <!-- <td>#{{ props.item.t_id }}</td> -->
                                <td class="text-left"><v-btn color="primary" :to="{name: 'invoiceDetail', params: {invoice_id: props.item.inv_id}}">View<v-icon right medium>visibility</v-icon></v-btn> #{{ props.item.inv_id }}</td>
                                <td class="text-left">{{ props.item.inv_invoiceable | capitalize }}</td>
                                <td class="text-left">{{ moment(props.item.inv_due_date).format("DD/MM/YYYY") }}</td>
                                <td class="text-left">{{ props.item.inv_amount | currency  }}</td>
                                <td class="text-left">{{ props.item.inv_paid | capitalize  }}</td>
                                <td class="text-left">{{owingPayments(props.item.inv_amount, props.item.inv_payments)}}</td>
                                <!-- <td class="justify-end align-center layout">
                                    <v-btn color="primary" :to="{name: 'invoiceDetail', params: {invoice_id: props.item.inv_id}}">View <v-icon right medium>visibility</v-icon></v-btn>
                                </td> -->
                            </tr>
                        </template>
                        <template slot="no-data">
                            <div class="justify-center align-center layout">
                                <v-icon left medium>warning</v-icon>Sorry, No Invoices Yet
                            </div>
                        </template>
                        <template slot="no-results">
                            <div class="justify-center align-center layout">
                                <v-icon left medium>warning</v-icon>Sorry, No Results found for "{{ search }}"
                            </div>
                        </template>
                    </v-data-table>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import store from './_store';
import moment from 'moment';

export default {
    name: 'InvoiceModule',
    components: {
        //
    },
    data () {
        return {
            moment: moment,
            search: '',
            headers: [
                { text: '#', value: 'inv_id' },
                { text: 'Member / Team', value: 'inv_invoiceable' },
                { text: 'Due Date', value: 'inv_due_date' },
                { text: 'Amount', value: 'inv_amount' },
                { text: 'Fully Paid', value: 'inv_paid' },
                { text: 'Owing', value: '' },
                // { text: 'Actions', align: 'right', sortable: false }
            ],
        }
    },
    computed: {
        invoicesLoading(){
            return this.$store.getters['invoice/invoiceStatus'] == 'loading';
        },
        invoices(){
            return this.$store.getters['invoice/invoices'];
        },
    },
    methods: {
        invoiceSubject(invoice){
            if(invoice.inv_legacy_teams){
                return invoice.inv_legacy_teams;
            }

            return invoice.inv_invoiceable;
        },
        total(payments){
            let sum = parseFloat(0.00);
            return payments.reduce(function(sum, payment){
                let discount = !_.isNil(payment.p_discount) ? payment.p_discount : 0.00;
                let amount = payment.p_amount;

                if(payment.p_refunded){
                    amount = payment.p_amount * -1;
                }

                return sum + parseFloat(amount) + parseFloat(discount);
            }, 0.00);
        },
        owingPayments(total, payments){
            let sum = !_.isEmpty(payments) ? this.total(payments) : 0;
            let owing = parseFloat(parseFloat(total) - parseFloat(sum)).toFixed(2);
            return this.$options.filters.currency(owing);
        },
    },
    beforeCreate(){
        // this.$store.dispatch('user/userRequest');
        if(_.isEmpty(this.$store.getters['invoice/invoices'])){
            this.$store.dispatch('invoice/invoiceRequest');
        }
    }
};
</script>

<style scoped>

</style>
